import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export default function AddProfileButton() {
  return (
    <Button variant="text">
      <a href="add-profile">
        <h3 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <AddIcon />
          Profile
        </h3>
      </a>
    </Button>
  );
}
